import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';

const healthStatusCheckState = (state: RootState) => state.healthStatusCheck;
const selectHealthStatusCheckState = createSelector(healthStatusCheckState, (healthStatusCheckState) => ({
  ...healthStatusCheckState,
}));

export { selectHealthStatusCheckState };
